import {
    FETCH_POLICIES_REQUEST,
    FETCH_POLICIES_SUCCESS,
    FETCH_POLICIES_FAILURE,
    ADD_POLICY_REQUEST,
    ADD_POLICY_SUCCESS,
    ADD_POLICY_FAILURE,
    UPDATE_POLICY_REQUEST,
    UPDATE_POLICY_SUCCESS,
    UPDATE_POLICY_FAILURE,
    DELETE_POLICY_REQUEST,
    DELETE_POLICY_SUCCESS,
    DELETE_POLICY_FAILURE,
  } from './types';
  
  import {
    fetchAllPolicies,
    createPolicy,
    updatePolicy,
    deletePolicy,
  } from '../../services/termsAndPoliciesService';
  
  // Action Creators
  
  // Fetch Policies Action Creators
  export const fetchPoliciesRequest = () => ({ type: FETCH_POLICIES_REQUEST });
  export const fetchPoliciesSuccess = (policiesData) => ({
    type: FETCH_POLICIES_SUCCESS,
    payload: policiesData,
  });
  export const fetchPoliciesFailure = (error) => ({
    type: FETCH_POLICIES_FAILURE,
    payload: error,
  });
  
  // Add Policy Action Creators
  export const addPolicyRequest = () => ({ type: ADD_POLICY_REQUEST });
  export const addPolicySuccess = (policyData) => ({
    type: ADD_POLICY_SUCCESS,
    payload: policyData,
  });
  export const addPolicyFailure = (error) => ({
    type: ADD_POLICY_FAILURE,
    payload: error,
  });
  
  // Update Policy Action Creators
  export const updatePolicyRequest = () => ({ type: UPDATE_POLICY_REQUEST });
  export const updatePolicySuccess = (policyData) => ({
    type: UPDATE_POLICY_SUCCESS,
    payload: policyData,
  });
  export const updatePolicyFailure = (error) => ({
    type: UPDATE_POLICY_FAILURE,
    payload: error,
  });
  
  // Delete Policy Action Creators
  export const deletePolicyRequest = () => ({ type: DELETE_POLICY_REQUEST });
  export const deletePolicySuccess = (policyId) => ({
    type: DELETE_POLICY_SUCCESS,
    payload: policyId,
  });
  export const deletePolicyFailure = (error) => ({
    type: DELETE_POLICY_FAILURE,
    payload: error,
  });
  
  // Thunks
  
  // Thunk to fetch all policies
  export const fetchPoliciesAction = (page = 1, size = 50) => async (dispatch) => {
    dispatch(fetchPoliciesRequest());
  
    try {
      const response = await fetchAllPolicies(page, size);
  
      if (response.error) {
        dispatch(fetchPoliciesFailure(response.error));
        return { success: false, error: response.error };
      } else {
        dispatch(fetchPoliciesSuccess(response));
        return { success: true, data: response };
      }
    } catch (error) {
      dispatch(fetchPoliciesFailure(error.message || "Failed to fetch policies"));
      return { success: false, error: error.message || "Failed to fetch policies" };
    }
  };
  
  // Thunk to create a new policy
  export const addPolicyAction = (policyData) => async (dispatch) => {
    dispatch(addPolicyRequest());
  
    try {
      const response = await createPolicy(policyData);
      console.log('API Response:', response);
  
      if (response.error) {
        dispatch(addPolicyFailure(response.error));
        return { success: false, error: response.error };
      } else {
        dispatch(addPolicySuccess(response.data));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(addPolicyFailure(error.message || "Failed to add policy"));
      return { success: false, error: error.message || "Failed to add policy" };
    }
  };
  
  // Thunk to update an existing policy
  export const updatePolicyAction = (policyId, policyData) => async (dispatch) => {
    dispatch(updatePolicyRequest());
  
    try {
      const response = await updatePolicy(policyId, policyData);
  
      if (response.error) {
        dispatch(updatePolicyFailure(response.error));
        return { success: false, error: response.error };
      } else {
        dispatch(updatePolicySuccess(response.data));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(updatePolicyFailure(error.message || "Failed to update policy"));
      return { success: false, error: error.message || "Failed to update policy" };
    }
  };
  
  // Thunk to delete a policy
  export const deletePolicyAction = (policyId) => async (dispatch) => {
    dispatch(deletePolicyRequest());
  
    try {
      const response = await deletePolicy(policyId);
  
      if (response.error) {
        dispatch(deletePolicyFailure(response.error));
        return { success: false, error: response.error };
      } else {
        dispatch(deletePolicySuccess(policyId));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(deletePolicyFailure(error.message || "Failed to delete policy"));
      return { success: false, error: error.message || "Failed to delete policy" };
    }
  };
  